import posIcon from "../assets/icons/universe-pos.png";
import uniCloudIcon from "../assets/icons/unicloud.png";
import scannerIcon from "../assets/icons/universe-scanner.png";

import posMain from "../assets/promos/universe-pos-main.png";
import posSecondary from "../assets/promos/universe-pos-secondary.png";
import uniCloudMain from "../assets/promos/unicloud-main.png";
import uniCloudSecondary from "../assets/promos/unicloud-secondary.png";
import scannerMain from "../assets/promos/universe-scanner-main.png";

const visuals = {
  "universe-pos": {
    icon: posIcon,
    featuredImage: posMain,
    cardImage: posSecondary,
    screenshots: [posMain, posSecondary],
    heroLabel: "Mobile point of sale",
    marketingTitle: "Your shop in your pocket.",
    marketingBody:
      "Sell faster, print receipts, manage customers, and keep checkout operations moving from your Android device.",
    highlights: [
      "Complete mobile sales and checkout experience.",
      "Quick access to cart, receipt, and sale confirmation workflows.",
      "Designed as a companion to the Universe Inventory POS ecosystem.",
    ],
  },
  unicloud: {
    icon: uniCloudIcon,
    featuredImage: uniCloudMain,
    cardImage: uniCloudSecondary,
    screenshots: [uniCloudMain, uniCloudSecondary],
    heroLabel: "Business activity and alerts",
    marketingTitle: "Your business. Live.",
    marketingBody:
      "Stay informed with real-time updates, low-stock alerts, staff activity, and important business notifications wherever you are.",
    highlights: [
      "Real-time activity feed for sales and staff events.",
      "Low-stock and operational update visibility on mobile.",
      "Perfect for owners and managers who need live visibility.",
    ],
  },
  "universe-scanner": {
    icon: scannerIcon,
    featuredImage: scannerMain,
    cardImage: scannerMain,
    screenshots: [scannerMain],
    heroLabel: "Barcode and QR scanning",
    marketingTitle: "Scan. Find. Keep moving.",
    marketingBody:
      "Connect your Android device to supported Universe POS workflows and scan barcode or QR items quickly and accurately.",
    highlights: [
      "Barcode and QR scanning in one app.",
      "Fast product lookup and item confirmation.",
      "Built to work alongside Universe POS register workflows.",
    ],
  },
  "universe-staff": {
    heroLabel: "Restricted workspace",
    marketingTitle: "Authorized staff tools.",
    marketingBody:
      "Protected mobile workspace for approved Universe personnel.",
    highlights: [
      "Restricted access for authorized staff only.",
      "Future secure workspace inside the Universe ecosystem.",
    ],
  },
  "universe-partner": {
    heroLabel: "Partner access",
    marketingTitle: "Partner tools, when approved.",
    marketingBody:
      "Restricted application experience for approved partners and agents.",
    highlights: [
      "Reserved for authorized partner access.",
      "Future tools for Universe growth and channel partners.",
    ],
  },
};

export const featuredClientSlugs = ["universe-pos", "unicloud", "universe-scanner"];

export function withAppVisuals(app) {
  const visual = visuals[app?.slug] || {};
  return {
    ...app,
    displayIcon: visual.icon || app?.displayIcon || null,
    featuredImage: visual.featuredImage || null,
    cardImage: visual.cardImage || visual.featuredImage || null,
    screenshots:
      Array.isArray(app?.screenshots) && app.screenshots.length
        ? app.screenshots
        : visual.screenshots || [],
    heroLabel: visual.heroLabel || null,
    marketingTitle: visual.marketingTitle || app?.name || null,
    marketingBody: visual.marketingBody || app?.shortDescription || null,
    highlights: visual.highlights || app?.highlights || [],
  };
}

export function getFeaturedVisual(slug) {
  return visuals[slug] || null;
}
